import axios from '@fs/zion-axios'

const BASE_TREE_PATH = '/service/dmc/tree'

export function getPersons(treeId, contactNames, nextPageToken, nameFilter, sort, pageSize) {
  const params = { contactNames, nextPageToken, nameFilter, sort, pageSize }
  return axios.get(`${BASE_TREE_PATH}/${treeId}/persons`, { params })
}

export function getMePersons(treeId) {
  return axios.get(`${BASE_TREE_PATH}/${treeId}/me-persons`)
}

export function getTree(treeId) {
  const url = `${BASE_TREE_PATH}/${treeId}`
  const response = axios.get(url)
  return response
}

export function getDmcTree(treeId) {
  const url = `${BASE_TREE_PATH}/${treeId}/dmc`
  const response = axios.get(url)
  return response
}

export function saveTree(treeId, tree) {
  return axios.post(`${BASE_TREE_PATH}/${treeId}`, tree)
}

export function getPersonCount(treeId) {
  return axios.get(`${BASE_TREE_PATH}/${treeId}/persons/count`)
}

export function getTreeGroups(treeId) {
  return axios.get(`${BASE_TREE_PATH}/${treeId}/groups`)
}

export function getTreeGroupMembers(treeId) {
  return axios.get(`${BASE_TREE_PATH}/${treeId}/groups/members`)
}

export function deleteTree(treeId) {
  const url = `${BASE_TREE_PATH}/${treeId}`
  const response = axios.delete(url)
  return response
}
